import React from 'react';
import { Link } from 'react-router-dom';
import styles from './styles.module.css';
const Logo = ({ color, alt, ...props }) => {
  return (
    (
      color === "colored" ?
        <Link className={styles.logo} to="/">
          <img src='../../../assets/logo/logo.svg' alt={alt} {...props} />
        </Link>
        :
        <Link className={styles.logo} to="/">
          <img src='../../../assets/logo/logo-white.svg' alt={alt} {...props} />
        </Link>
    )
  );
};

export default Logo;
